export const init = (survey: any) => {
  const timepicker = {
    name: 'timepicker',
    title: 'Time Picker',
    iconName: '',
    widgetIsLoaded: () => true,
    isFit: (question) => question.getType() === 'timepicker',

    activatedByChanged: (activatedBy) => {
      survey.JsonObject.metaData.addClass('timepicker', [], null, 'text');
      survey.JsonObject.metaData.addProperties('timepicker', [
        { name: 'buttonText', default: 'Now' },
      ]);
    },
    isDefaultRender: false,
    htmlTemplate: `<div><input type='time' id='appt' name='appt'>
        <input type="button" class="sv-btn sv-paneldynamic__add-btn sv-paneldynamic__add-btn--list-mode" style="margin-top: 0;">
      </div>`,
    afterRender: (question, el) => {
      const text = el.getElementsByTagName('input')[0];
      text.inputType = question.inputType;
      text.placeholder = question.placeHolder;
      const button = el.getElementsByTagName('input')[1];
      button.value = question.buttonText;

      button.onclick = () => {
        const now = new Date();
        const hh = `00${now.getHours()}`.substr(-2);
        const mm = `00${now.getMinutes()}`.substr(-2);
        text.value = `${hh}:${mm}`;
        question.value = text.value;
      };

      text.onchange = () => {
        question.value = text.value;
      };
      const onValueChangedCallback = () => {
        text.value = question.value ? question.value : '';
      };
      const onReadOnlyChangedCallback = () => {
        if (question.isReadOnly) {
          text.setAttribute('disabled', 'disabled');
          button.setAttribute('disabled', 'disabled');
        } else {
          text.removeAttribute('disabled');
          button.removeAttribute('disabled');
        }
      };

      question.readOnlyChangedCallback = onReadOnlyChangedCallback;
      onReadOnlyChangedCallback();
      question.valueChangedCallback = onValueChangedCallback;
      onValueChangedCallback();
    },

    willUnmount: (question, el) => {
    },
  };

  survey.CustomWidgetCollection.Instance.addCustomWidget(timepicker, 'customtype');
};
